const hu = {
    home: 'Home',
    services: 'Szolgáltatások',
    appointments: 'Időpontok',
    bookings: 'Foglalások',
    statistics: 'Statisztikák',
    users: 'Felhasználók',
    login: 'Bejelentkezés',
    register: 'Regisztráció',
    profile: 'Profil',
    logout: 'Kijelentkezés',
    language: 'Nyelv',
    packages: 'Csomagok',
    select_service: 'Szolgáltatás kiválasztása:',
    choose_service: 'Válasszon szolgáltatást',
    capacity: 'Férőhelyek száma:',
    people: 'fő',
    select_interval: 'Időintervallum kiválasztása:',
    minutes_15: '15 perc',
    minutes_20: '20 perc',
    minutes_30: '30 perc',
    minutes_60: '1 óra',
    select_service_alert: 'Kérjük, válasszon egy szolgáltatást a listából!',
    login_error: 'Bejelentkezési probléma, próbálkozz újra!',
    move_failed: 'Nem sikerült az áthelyezés.',
    booking_failed: 'Nem sikerült a foglalás.',
    delete_booking_failed: 'Nem sikerült a foglalás törlése.',
    confirm_delete: 'Biztosan törölni szeretné az eseményt?',
    today: 'Ma',
    month: 'Hónap',
    week: 'Hét',
    day: 'Nap',
    yes: 'Igen',
    no: 'Nem',
    service: 'Szolgáltatás',
    start_time: 'Időpont kezdete:',
    end_time: 'Időpont vége:',
    name: 'Név',
    actions: 'Műveletek',
    accept: 'Elfogadás',
    reject: 'Elutasítás',
    delete: 'Törlés',
    move: 'Áthelyezés',
    cancel: 'Mégse',
    confirm_appointment_delete: 'Biztosan törölni szeretné ezt az időpontot?',
    book_by_name: 'Foglalás névre',
    enter_name: 'Adja meg a nevét a foglaláshoz:',
    book: 'Foglalás',
    appointment_delete: 'Időpont törlése',
    move_appointment: 'Időpont áthelyezése',
    delete_appointment: 'Időpont törlése',
    package_title: 'Szolgáltatás Csomagok',
    hours: 'óra',
    minutes: 'perc',
    edit: 'Szerkesztés',
    no_packages: 'Nincs elérhető csomag ehhez a szolgáltatáshoz.',
    add_new_package: 'Új csomag hozzáadása',
    add_package_desc: 'Hozzáadhat egy új csomagot ehhez a szolgáltatáshoz.',
    edit_package: 'Csomag Szerkesztése',
    new_package: 'Új Csomag Hozzáadása',
    description: 'Leírás',
    duration_hours: 'Időtartam (Órák)',
    duration_minutes: 'Időtartam (Percek)',
    add: 'Hozzáadás',
    save: 'Mentés',
    profile_data: 'Profil adatok',
    upload_picture: 'Kép feltöltése',
    username: 'Felhasználónév',
    first_name: 'Keresztnév',
    last_name: 'Vezetéknév',
    email: 'Email',
    phone_number: 'Telefonszám',
    update_data: 'Adatok Frissítése',
    profile_update_error: 'Hiba történt az adatok frissítésekor',
    profile_update_success: 'Adatok sikeresen frissítve',
    profile_picture_upload_error: 'Hiba történt a profilkép feltöltésekor',
    existing_services: 'Meglévő Szolgáltatások',
    choose_category: 'Válasszon kategóriát',
    update_service: 'Szolgáltatás Frissítése',
    details: 'Részletek',
    service_name: 'Szolgáltatás Neve',
    category: 'Kategória',
    available: 'Elérhető',
    create_service: 'Új Szolgáltatás Létrehozása',
    image_upload_error: 'Hiba történt a kép feltöltésekor',
    general_error: 'Hiba: ',
    delete_service_error: 'Hiba történt a szolgáltatás törlése során: ',
    create_success: 'Szolgáltatás sikeresen létrehozva',
    update_success: 'Szolgáltatás sikeresen frissítve',
    category_label: 'Kategória',
    available_label: 'Elérhető',
    provider: 'Szolgáltató',
    no_package_available: 'Nincsenek elérhető csomagok ehhez a szolgáltatáshoz.',
    forgot_password_title: 'Elfelejtett jelszó',
    reset_password: 'Jelszó visszaállítása',
    reset_email_sent: 'Ellenőrizd az email fiókodat a jelszó-visszaállító linkért.',
    error_try_again: 'Hiba történt. Kérjük, próbáld újra.',
    network_error: 'Hálózati hiba. Kérjük, próbáld újra később.',
    no_account: 'Nincs fiókod?',
    forgot_password: 'Elfelejtett jelszó?',
    password: 'Jelszó',
    confirm_password: 'Jelszó megerősítése',
    consent_prefix: '„Hozzájárulok, hogy személyes adataimat az ',
    privacy_policy: 'Adatvédelmi nyilatkozatban',
    consent_suffix: ' foglaltak szerint kezeljék. Tudomásul veszem, hogy a hozzájárulásomat bármikor visszavonhatom.”',
    must_accept_privacy: 'El kell fogadnia az adatvédelmi nyilatkozatot a regisztrációhoz.',
    passwords_do_not_match: 'A megadott jelszavak nem egyeznek!',
    registration_success: 'Aktiváljon az e-mailben kapott linkkel. Nézze meg a Spam mappát is.',
    privacy_modal_title: 'Adatvédelmi nyilatkozat',
    privacy_modal_1_title: '1. Az adatkezelő neve és elérhetősége',
    privacy_modal_1_content: 'A szolgáltatást működtető vállalat neve, címe és elérhetőségei.',
    privacy_modal_2_title: '2. Gyűjtött adatok',
    privacy_modal_2_content: 'A következő személyes adatokat gyűjtjük: név, email cím, telefonszám, IP cím, valamint a szolgáltatás használatára vonatkozó adatok.',
    privacy_modal_3_title: '3. Az adatkezelés célja és jogalapja',
    privacy_modal_3_content: 'Az adatkezelés célja a regisztráció biztosítása, kapcsolattartás és a szolgáltatás nyújtása. Jogalap: önkéntes hozzájárulás, amely bármikor visszavonható.',
    privacy_modal_4_title: '4. Az adatok tárolási ideje',
    privacy_modal_4_content: 'Az adatokat csak a szükséges ideig tároljuk, vagy a jogszabályi előírások szerint.',
    privacy_modal_5_title: '5. Adatbiztonsági intézkedések',
    privacy_modal_5_content: 'Műszaki és szervezési intézkedéseket alkalmazunk az adatok biztonságos tárolása érdekében.',
    privacy_modal_6_title: '6. Adattovábbítás és adatfeldolgozók',
    privacy_modal_6_content: 'Az adatok harmadik félnek csak a felhasználó kifejezett hozzájárulásával vagy jogszabály alapján kerülnek átadásra.',
    privacy_modal_7_title: '7. Felhasználói jogok',
    privacy_modal_7_list1: 'Hozzáférési jog: kérheti a róla tárolt adatokhoz való hozzáférést.',
    privacy_modal_7_list2: 'Helyesbítés joga: kérheti a pontatlan adatok helyesbítését.',
    privacy_modal_7_list3: 'Törléshez való jog: kérheti az adatok törlését, ha már nincs szükség rájuk.',
    privacy_modal_8_title: '8. Kapcsolat',
    privacy_modal_8_content: 'Adatkezeléssel kapcsolatos kérdésekben az alábbi email címen érhet el minket: [email protected]',
    new_password: 'Új jelszó',
    password_reset_success: 'A jelszavad sikeresen visszaállítva.',
    error_occurred: 'Hiba történt.',
    loading_data: 'Adatok betöltése...',
    select_package: 'Válasszon csomagot',
    choose: 'Kiválaszt',
    no_packages_for_appointment: 'Nincsenek elérhető csomagok ehhez az időponthoz.',
    no_packages_for_service: 'Nincsenek csomagok ehhez a szolgáltatáshoz.',
    price: 'Ár',
    duration: 'Időtartam',
    view: 'Megnéz',
    sms_notification: 'SMS értesítés',
    email_notification: 'Email értesítés',
    bookings_title: 'Foglalások',
    no_bookings: 'Nincs foglalás',
    used_package: 'Használt csomag',
    package_name: 'Csomag neve',
    package_description: 'Leírás',
    package_price: 'Ár',
    package_duration: 'Időtartam',
    duration_0: '0 óra 0 perc',
    no_package_attached: 'Nincs csomag társítva.',
    open_in_calendar: 'Megnyitás a naptárban',
    close: 'Bezárás',
    confirmed: 'Elfogadva',
    pending: 'Függőben',
    rejected: 'Elutasítva',
    all_categories: 'Összes kategória',
    status_confirmed: 'Elfogadva',
    status_pending: 'Függőben',
    status_rejected: 'Elutasítva',
    statistics_loading_error: 'Hiba történt a statisztikák betöltésekor',
    total_bookings: 'Összes foglalás',
    most_booked_service: 'Legnépszerűbb szolgáltatás',
    total_services: 'Összes szolgáltatás',
    bookings_by_service: 'Foglalások csoportosítása szolgáltatás szerint',
    bookings_by_package: 'Foglalások csoportosítása csomag szerint',
    booking_count: 'Foglalások száma',
    loading: 'Betöltés...',
    confirm_booking: "Biztosan szeretnél foglalni erre az időpontra?",
    confirm_cancel_booking: "Biztosan törölni szeretnéd a foglalást?",
    failed_cancel_booking: "Nem sikerült a foglalás törlése.",
    error_delete_booking: 'Hiba az időpont törlése során:',
    client_list: 'Kliensek listája',
    clients: 'Kliensek',
    client_name: 'Név',
    client_email: 'Email',
    client_phone: 'Telefonszám',
    status: 'Státusz',
    client_blocked_successfully: 'A kliens sikeresen le lett tiltva',
    block: 'Tiltás',
    client_blocked_successfully: 'Kliens sikeresen le lett tiltva.',
    client_unblocked_successfully: 'Kliens sikeresen fel lett oldva.',
    block: 'Letiltás',
    unblock: 'Feloldás',  
    service_not_visible: "Ön le van tiltva ennél a szolgáltatónál.",
    delete_booking: 'Foglalás törlése',
    confirm_cancel_booking: "Biztosan lemondja a foglalását?",
    booking_cancelled_success: "A foglalás sikeresen törölve lett.",
    booking_cancelled_error: "Nem sikerült törölni a foglalást.",
    not_booked_by_you: "Ez az időpont nem az Ön foglalása.",  
    booking_success: 'A csomag sikeresen lefoglalva.',
    booking_failed: 'Nem sikerült a csomag foglalása.',
    booking_error: 'Hiba történt a foglalás során.',
    confirm_delete_package: "Biztosan törölni szeretné ezt a csomagot?",
    package_deleted_success: "A csomag sikeresen törölve.",
    package_deleted_error: "Nem sikerült a csomag törlése.",
    user_type: "Felhasználói típus",
    client: "Kliens (időpontokat foglal)",
    provider: "Cég (szolgátatásokat nyújt)",
    nav_title: "Navigáció",
    nav_home: "Home",
    nav_services: "Szolgáltatások",
    nav_appointments: "Időpontok",
    nav_bookings: "Foglalások",
    nav_statistics: "Statisztika",
    nav_users: "Felhasználók",
    bookings_at_my_services: 'Foglalások a szolgáltatásaimnál',
    my_bookings: 'Saját foglalásaim',
    nav_my_bookings: "Saját foglalásaim",
    nav_profile: "Profil",
    extra_title: "Extra",
    extra_notifications: "Értesítések",
    extra_messages: "Üzenetek",
    extra_favorites: "Kedvencek",
    extra_help: "Súgó & GYIK",
    extra_privacy: "Adatvédelem",
    extra_settings: "Beállítások",
    system_title: "Rendszer",
    system_language: "Nyelv",

    auth_logout: "Kijelentkezés",
    auth_login: "Bejelentkezés",
    footer_copy: "© {year} MyServiceHub",
    nav_home_l1: "Főoldal",
    nav_home_l2: "",
  
    nav_services_l1: "Szolgálta",
    nav_services_l2: "tások",
  
    nav_appointments_l1: "Időpon",
    nav_appointments_l2: "tok",
  
    nav_bookings_l1: "Foglalá",
    nav_bookings_l2: "sok",
  
    nav_statistics_l1: "Statiszti",
    nav_statistics_l2: "ka",
  
    nav_users_l1: "Felhaszná",
    nav_users_l2: "lók",

    subnav_appointments_l1: "Időpon",
    subnav_appointments_l2: "tok",
    
    subnav_services_l1: "Szolgáltatá",
    subnav_services_l2: "sok",
    
    subnav_packages_l1: "Csoma",
    subnav_packages_l2: "gok",
    
    subnav_clients_l1: "Ügyfe",
    subnav_clients_l2: "lek",

    home_badge: 'Szolgáltatások • Foglalás • Egyszerűen',
    home_hero_title: 'Foglalj időpontot pillanatok alatt',
    home_hero_subtitle: 'Találd meg a megfelelő szolgáltatót és foglalj online – gyorsan, átláthatóan, 0 stresszel.',
    home_cta_browse: 'Böngéssz szolgáltatások között',
    home_cta_register: 'Csatlakozz szolgáltatóként',
    features_title: 'Miért a MyServiceHub?',
    feature_1_title: 'Átlátható foglalás',
    feature_1_desc: 'Valós idejű elérhetőség, egyértelmű árak és időtartamok.',
    feature_2_title: 'Értesítések',
    feature_2_desc: 'Email/SMS emlékeztetők, hogy semmi ne maradjon le.',
    feature_3_title: 'Statisztikák a profiknak',
    feature_3_desc: 'Legnépszerűbb szolgáltatások, forgalmas időszakok – minden egy helyen.',
    feature_4_title: 'Villámgyors kezdés',
    feature_4_desc: 'Pár kattintás és már fogadhatod is a foglalásokat.',
    how_title: 'Hogyan működik?',
    how_1_title: 'Keresés',
    how_1_desc: 'Válassz kategóriát és böngéssz a szolgáltatók között.',
    how_2_title: 'Foglalás',
    how_2_desc: 'Válaszd ki az időpontot és foglald le egy pillanat alatt.',
    how_3_title: 'Értesítés',
    how_3_desc: 'Emlékeztetőt küldünk, hogy biztosan ott legyél időben.',
    testimonials_title: 'Visszajelzések',
    testimonial_1_quote: 'Végre egy platform, ami tényleg megkönnyíti a foglalásokat!',
    testimonial_1_name: 'Nóra, kozmetikus',
    testimonial_2_quote: 'Láthatóan több az ügyfelem, mióta itt vagyok.',
    testimonial_2_name: 'Márk, edző',
    cta_banner_title: 'Kezdd el most!',
    cta_banner_subtitle: 'Hozz létre profilt vagy böngéssz a szolgáltatások között.',
    cta_banner_btn_browse: 'Szolgáltatások',
    cta_banner_btn_register: 'Regisztráció',
    address: 'Cím',
    enter_address: 'Add meg a címet',
    // Szabadságok
    subnav_vacations_l1: "Szabadsá",
    subnav_vacations_l2: "gok",
    vacations: "Szabadságok",

    // Táblázat / űrlap
    from: "Kezdete",
    to: "Vége",
    note: "Megjegyzés",
    action: "Művelet",
    no_data: "Nincs adat",

    // Térkép
    view_on_map: "Térképen megnyit",
    on_vacation: 'Szabadság',
    all_day: 'Egész nap',
    notifications_title: "Értesítések",
    notifications_loading: "Betöltés…",
    notifications_empty: "Nincs megjeleníthető értesítés.",
    notifications_filter: "Szűrő",
    notifications_filter_all: "Összes",
    notifications_filter_unread: "Olvasatlan",
    notifications_filter_read: "Olvasott",
    notifications_search_ph: "Keresés címben vagy üzenetben…",
    notifications_refresh: "Frissítés",
    notifications_mark_all: "Összes megjelölése olvasottnak",
    notifications_mark_read: "Olvasottnak",
    notifications_mark_unread: "Olvasatlannak",
    notifications_delete: "Törlés",
    notifications_open_related: "Kapcsolódó oldal megnyitása",
    notifications_item_no_title: "Cím nélkül",
    notifications_unread_chip: "{n} olvasatlan",
    notifications_unread_dot: "Olvasatlan jelző",
    notifications_fallback: "A szerver nem elérhető – demó adatok láthatók.",
    badge_unread: "Olvasatlan értesítések száma",
    extra_notifications: "Értesítések", // ha eddig is volt, maradhat
    delete_account: 'Fiók törlése',
    confirm_delete_account: 'Biztosan törölni szeretnéd a fiókodat? Ez a művelet nem visszavonható.',
    account_deleted_success: 'A fiókodat sikeresen töröltük.',
    account_deleted_error: 'Hiba történt a fiók törlése közben.',
    or: "vagy",
    google_login_failed: "A Google-bejelentkezés nem sikerült. Próbáld újra.",
    must_accept_privacy: "A folytatáshoz el kell fogadnod az adatvédelmi feltételeket.",
    registration_success_email_sent: 'Aktiváljon az e-mailben kapott linkkel. Nézze meg a Spam mappát is.',
    registration_success_auto_activated: 'Sikeres regisztráció! A fiók azonnal aktiválva lett a Google ellenőrzés alapján.',
    please_choose: '— Kérjük, válasszon —',
    phone_required: 'Kérjük, adjon meg érvényes telefonszámot.',
    user_type_required: 'Kérjük, válassza ki a felhasználói típust.',
    continue_with_google: 'Folytatás Google-lel.',
    choose_country: 'Összes ország',
    country: 'Ország',
    city: 'Város',
    select_city: 'Összes várost',
    client_packages: 'Kliens csomagjai',
    select_client: 'Foglaló kiválasztása',
    no_packages_for_appointment: 'Nincs csomag ehhez az időponthoz.',
    loading_data: 'Betöltés...',
    free: 'Szabad',
    no_user_for_selected_booking: 'Ehhez a foglaláshoz nincs felhasználó (név alapján lett felvéve), ezért nem kérhetők le csomagok.',
    missing_user_id: 'Hiányzik a user_id paraméter.',
    invalid_user_id: 'Hibás user azonosító.',
    choose_country_first: "Előbb válasszon országot",
  };
  
  export default hu;
  